import { SystemStyleObject } from '@chakra-ui/react';

export const getStyles = (
  isOver: boolean,
  isHovered: boolean,
  isDraggingAnyFolder: boolean,
  isDraggingCurrentFolder: boolean,
  offset: number
) => {
  const isFolderDrag = isDraggingAnyFolder || isDraggingCurrentFolder;
  const hoveredSx = {
    color: 'textBase',
    bg: 'surface2',
    ' svg': {
      display: 'none',
      '&.active': {
        display: 'block',
      },
    },
    ' p:first-of-type': {
      fontWeight: 500,
    },
  };

  const dragHoverSx: SystemStyleObject = {
    borderColor: 'B.80',
    cursor: 'copy',
    ...hoveredSx,
  };

  const folderDragOverSx: SystemStyleObject =
    offset < 0
      ? {
          borderTop: '1px solid',
          borderTopColor: 'B.80',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        }
      : {
          borderBottom: '1px solid',
          borderBottomColor: 'B.80',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        };

  const rootSx: SystemStyleObject = {
    color: 'M.60',
    border: '1px solid',
    borderRadius: 4,
    borderColor: 'transparent',
    mx: 'auto',
    py: 0,
    px: 2,
    h: '42px',
    _hover: {},
    ...(isHovered && !isFolderDrag ? hoveredSx : {}),
    ...(isOver && !isFolderDrag ? dragHoverSx : {}),
    ...(isDraggingCurrentFolder ? dragHoverSx : {}),
    ...(isOver && isFolderDrag ? folderDragOverSx : {}),
    ...(isFolderDrag
      ? {
          cursor: 'grabbing !important',
          userSelect: 'none',
        }
      : {}),
    _activeLink: {
      bg: 'surface2',
    },
  };

  return { rootSx };
};
